import React from "react";
import "../../../../css/Turismo/turismo.css";
import "../../../../css/Turismo/lugares.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

// Puedes agregar más imágenes y datos según lo necesites
const lugares = [
  {
    nombre: "Capilla San Cayetano",
    imagenes: [
      require("../../../img/lugares/Capilla-san-cayetano.jpg"),
    ],
    maps: "https://maps.app.goo.gl/zB5PcXXj94tvrTQD7",
    direccion: "25 de Mayo 302",
  },
  {
    nombre: "Dr. Emilio Vidal Abal",
    imagenes: [
      require("../../../img/lugares/Colonia-1.jpg"),
      require("../../../img/lugares/Colonia-2.jpg"),
    ],
    maps: "https://maps.app.goo.gl/enXeahGZ2WTs2dhe6",
    direccion: "Ruta Nacional 9 Km. 609.",
  },
  {
    nombre: "Estación Ferrocarril",
    imagenes: [
      require("../../../img/lugares/Estación-Ferrocarril.jpeg"),
    ],
    maps: "https://maps.app.goo.gl/D55gSazrVpqJrknt9",
    direccion: "Estación Oliva FC Mitre",
  },
  {
    nombre: "Iglesia Medalla Milagrosa",
    imagenes: [
      require("../../../img/lugares/Iglesia-Medalla-Milagrosa-3.jpg"),
    ],
    maps: "https://maps.app.goo.gl/XBfXbsZ5ptxmWTob7",
    direccion: "Bartolomé Mitre 901",
  },
  // Agrega el resto de los lugares aquí siguiendo el mismo formato...
];

const Carousel = ({ imagenes, id }) => {
  if (imagenes.length === 1) {
    return (
      <div className="imagen-lugares">
        <img src={imagenes[0]} alt="" />
      </div>
    );
  }
  return (
    <div id={id} className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        {imagenes.map((img, idx) => (
          <div className={`carousel-item${idx === 0 ? " active" : ""}`} key={idx}>
            <img src={img} alt="" />
          </div>
        ))}
      </div>
      <button className="carousel-control-prev" type="button" data-bs-target={`#${id}`} data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Anterior</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target={`#${id}`} data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Siguiente</span>
      </button>
    </div>
  );
};

const Lugares = () => (
  <div>
    <div
      className="lugares text-center"
      style={{
        backgroundImage: `url(${require("../../../img/lugares/portada-lugares.jpg")})`,
      }}
    >
      {/* Overlay */}
      <div className="lugares-overlay" />
    </div>
    <div className="container">
      <div className="frm-lugares">
        <h6 className="titulo-lugares text-center">Lugares para visitar de nuestra ciudad</h6>
        <div className="row">
          {lugares.map((lugar, idx) => (
            <div className="col-12" key={idx}>
              <div className="vista-lugares">
                <div className="row">
                  <h4>{lugar.nombre}</h4>
                  <section className="col-12 col-md-6">
                    <Carousel imagenes={lugar.imagenes} id={`carouselLugar${idx}`} />
                  </section>
                  <section className="col-12 col-md-6 align-self-center">
                    <a href={lugar.maps} target="_blank" rel="noopener noreferrer">
                      <div className="informacion-lugares text-center">
                        <FontAwesomeIcon icon={faLocationDot} />
                        <br />
                        <p>{lugar.direccion}</p>
                      </div>
                    </a>
                  </section>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default Lugares;